/// <reference path="../Party/PartyGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.element("<div/>")
    @Serenity.Decorators.registerEditor([Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly])
    export class PartyRolePartiesEditor extends PartyGrid implements Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly {
        protected getColumnsKey() { return 'Data.PartyRoleParties'; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getColumns() {
            var columns = super.getColumns();

            var selectColumn = Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection);
            var selectColumnFormat = selectColumn.format;
            selectColumn.format = ctx => this.readOnly ? "" : selectColumnFormat(ctx);
            columns.splice(0, 0, selectColumn);

            return columns;
        }

        protected getPersistanceStorage() {
            return null;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getButtons(): Serenity.ToolButton[] {
            return [
                {
                    title: 'Add Parties to Party Role',
                    cssClass: 'add-parties-button',
                    icon: 'fa-search-plus',
                    onClick: () => {
                        var dlg = new PartyPickerDialog();
                        dlg.onSuccess = (selected) => {
                            var value = (this.value || []).slice();
                            var existing: Q.Dictionary<boolean> = {};
                            for (let x of value || [])
                                existing[x] = true;

                            for (let s of selected.map(x => x.PartyCode))
                                if (!existing[s]) {
                                    value.push(s);
                                    existing[s] = true;
                                }

                            this.value = value;
                            return true;
                        };

                        dlg.dialogOpen();
                    }
                }, {
                    title: 'Remove Selected',
                    cssClass: 'remove-selected-button',
                    icon: 'fa-times',
                    onClick: () => {
                        var remove: Q.Dictionary<boolean> = {};
                        var keys = this.rowSelection.getSelectedKeys();
                        if (!keys.length) {
                            Q.notifyWarning("Please select parties to remove!");
                            return;
                        }
                        for (var k of keys) {
                            remove[k] = true;
                        }
                        var value = (this.value || []).filter(x => !remove[x]);
                        this.value = value;
                        this.rowSelection.setSelectedKeys([]);
                    }
                }];
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this._value && this._value.length > 0;
        }

        public getEditValue(property, target) {
            target[property.name] = this.value;
        }

        public setEditValue(source, property) {
            this.value = source[property.name];
        }

        private _value: string[];

        public get value(): string[] {
            return this._value || [];
        }

        public set value(value: string[]) {
            this._value = value;
            this.setEquality(PartyRow.Fields.PartyCode, this._value ? this._value : ['?']);
            if (!value || !value.length) {
                this.setItems([]);
            }
            else
                this.refresh();
        }

        private _readOnly: boolean;

        public get_readOnly() {
            return this._readOnly;
        }

        public set_readOnly(value: boolean) {
            if (!!value !== !!this._readOnly) {
                this._readOnly = !!value;

                this.toolbar.findButton('add-parties-button').toggleClass('disabled', this._readOnly);
                this.toolbar.findButton('remove-selected-button').toggleClass('disabled', this._readOnly);
                this.slickGrid.invalidate();
            }
        }
    }
}